<ng-template [ngIf]="selectedDepartement" [ngIfElse]="emptyDropdown">
  <div class="stats_container border border-2 rounded-2 d-flex">
    <img
      class="object-fit-scale"
      src="assets/images/stats-avct/{{ selectedDepartement.code }}-avct.jpg"
      alt="Statistique avant-contrat du département {{
        selectedDepartement.name
      }}"
      title="Statistique avant-contrat du département {{
        selectedDepartement.name
      }}"
    />
  </div>
</ng-template>

<ng-template #emptyDropdown>
  <div class="mt-3 fw-semibold text-primary">
    Veuillez sélectionner un département
  </div>
</ng-template>
